import { Icon, IconProps } from "../";

export const TriangleBottomIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M12.866 18.5C12.4811 19.1667 11.5189 19.1667 11.134 18.5L4.20578 6.5C3.82088 5.83333 4.302 5 5.0718 5H18.9282C19.698 5 20.1791 5.83333 19.7942 6.5L12.866 18.5Z" />
    </Icon>
  );
};
